export default function(key, value) {
  localStorage[key] = value;
}
